import _toConsumableArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useState } from 'react';
import { isFormList, formList } from './form-list/form-list.js';
import { validateValues, validateFieldValue } from './validate-values/validate-values.js';
import { filterErrors } from './filter-errors/filter-errors.js';
import { getInputOnChange } from './get-input-on-change/get-input-on-change.js';
import { getErrorPath } from './get-error-path/get-error-path.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function useForm(_ref) {
  var initialValues = _ref.initialValues,
      initialErrors = _ref.initialErrors,
      rules = _ref.validate,
      schema = _ref.schema;

  var _useState = useState(filterErrors(initialErrors)),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(initialValues),
      _useState4 = _slicedToArray(_useState3, 2),
      values = _useState4[0],
      setValues = _useState4[1];

  var clearErrors = function clearErrors() {
    return setErrors({});
  };

  var setFieldError = function setFieldError(field, error) {
    return setErrors(function (current) {
      return __spreadProps(__spreadValues({}, current), _defineProperty({}, field, error));
    });
  };

  var clearFieldError = function clearFieldError(field) {
    return setErrors(function (current) {
      var clone = __spreadValues({}, current);

      delete clone[field];
      return clone;
    });
  };

  var setFieldValue = function setFieldValue(field, value) {
    setValues(function (currentValues) {
      return __spreadProps(__spreadValues({}, currentValues), _defineProperty({}, field, value));
    });
    clearFieldError(field);
  };

  var setListItem = function setListItem(field, index, value) {
    var list = values[field];

    if (isFormList(list) && list[index] !== void 0) {
      var cloned = _toConsumableArray(list);

      cloned[index] = value;
      setFieldValue(field, formList(cloned));
    }
  };

  var removeListItem = function removeListItem(field, indices) {
    var list = values[field];

    if (isFormList(list)) {
      setFieldValue(field, formList(list.filter(function (_, index) {
        return Array.isArray(indices) ? !indices.includes(index) : indices !== index;
      })));
    }
  };

  var addListItem = function addListItem(field, payload) {
    var list = values[field];

    if (isFormList(list)) {
      setFieldValue(field, formList([].concat(_toConsumableArray(list), [payload])));
    }
  };

  var reorderListItem = function reorderListItem(field, _ref2) {
    var from = _ref2.from,
        to = _ref2.to;
    var list = values[field];

    if (isFormList(list) && list[from] !== void 0 && list[to] !== void 0) {
      var cloned = _toConsumableArray(list);

      var item = list[from];
      cloned.splice(from, 1);
      cloned.splice(to, 0, item);
      setFieldValue(field, formList(cloned));
    }
  };

  var validate = function validate() {
    var results = validateValues(schema || rules, values);
    setErrors(results.errors);
    return results;
  };

  var validateField = function validateField(field) {
    var results = validateFieldValue(field, schema || rules, values);
    results.hasError ? setFieldError(field, results.error) : clearFieldError(field);
    return results;
  };

  var onSubmit = function onSubmit(handleSubmit) {
    return function (event) {
      event.preventDefault();
      var results = validate();
      !results.hasErrors && handleSubmit(values, event);
    };
  };

  var reset = function reset() {
    setValues(initialValues);
    clearErrors();
  };

  var getInputProps = function getInputProps(field) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        type = _ref3.type,
        _ref3$withError = _ref3.withError,
        withError = _ref3$withError === void 0 ? true : _ref3$withError;

    var value = values[field];
    var onChange = getInputOnChange(function (val) {
      return setFieldValue(field, val);
    });
    var payload = type === "checkbox" ? {
      checked: value,
      onChange: onChange
    } : {
      value: value,
      onChange: onChange
    };

    if (withError && errors[field]) {
      payload.error = errors[field];
    }

    return payload;
  };

  var getListInputProps = function getListInputProps(field, index, listField) {
    var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        type = _ref4.type,
        _ref4$withError = _ref4.withError,
        withError = _ref4$withError === void 0 ? true : _ref4$withError;

    var list = values[field];

    if (isFormList(list) && list[index] && listField in list[index]) {
      var listValue = list[index];
      var value = listValue[listField];
      var onChange = getInputOnChange(function (val) {
        return setListItem(field, index, __spreadProps(__spreadValues({}, listValue), _defineProperty({}, listField, val)));
      });
      var payload = type === "checkbox" ? {
        checked: value,
        onChange: onChange
      } : {
        value: value,
        onChange: onChange
      };
      var error = errors[getErrorPath([field, index, listField])];

      if (withError && error) {
        payload.error = error;
      }

      return payload;
    }

    return {};
  };

  return {
    values: values,
    setValues: setValues,
    setFieldValue: setFieldValue,
    errors: errors,
    setErrors: setErrors,
    clearErrors: clearErrors,
    clearFieldError: clearFieldError,
    setFieldError: setFieldError,
    setListItem: setListItem,
    removeListItem: removeListItem,
    addListItem: addListItem,
    reorderListItem: reorderListItem,
    validate: validate,
    validateField: validateField,
    onSubmit: onSubmit,
    reset: reset,
    getInputProps: getInputProps,
    getListInputProps: getListInputProps
  };
}

export { useForm };